// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

export class NewsBlockDTO {
  templateId!: string;
  inputs!: NewsInputDTO[];
}

export class NewsInputDTO {
  inputType!: string;
  content!: string;
}
